import React, { Component } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import getRelativeUrl from 'utils/getRelativeUrl'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

export default class ProductLandingGallery extends Component {
  render() {
    const { images } = this.props

    return (
      <Wrapper>
        <Container fluid>
          <Row>
            {images.map((image, index) => (
              <Col sm={12 / images.length}>
                {image.title && (
                  image.link ? (
                    <Link to={getRelativeUrl(image.link)}>
                      <Title>{image.title}</Title>
                    </Link>

                  ) : (
                    <Title>{image.title}</Title>
                  )
                )}
                
                {image.link ? (
                  <Link to={getRelativeUrl(image.link)}>
                    <Image
                      image={image.image.sourceUrl}
                      mobileImage={image.imageMobile.sourceUrl}
                    />
                  </Link>
                ) : (
                  <Image
                    image={image.image.sourceUrl}
                    mobileImage={image.imageMobile.sourceUrl}
                  />
                )}

                {image.description && (
                  <Description>{image.description}</Description>
                )}
              </Col>
            ))}
          </Row>
        </Container>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 65px;

  a {
    color: inherit;
  }
`

const Title = styled.h3`
  font-size: 18px;
  font-weight: 300;
  text-transform: uppercase;
`

const Image = styled.div`
  height: 350px;
  background: url(${props => props.image}) center / cover;

  ${media.xs`
    background: url(${props => props.mobileImage}) center / cover;
  `}
`

const Description = styled.p`
  font-size: 18px;
  font-weight: 300;
  color: ${props => props.theme.colors.text};
  margin-top: 0.5em;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductLandingGallery/index.js